<div class="flex flex-row justify-between mt-2">
  <h2 mat-dialog-title>Crop Image</h2>
  <div class="toolbar flex items-center gap-2">

    <button mat-raised-button color="primary" (click)="zoomOut()">
      <mat-icon>zoom_out</mat-icon>
      Zoom out
    </button>

    <button mat-raised-button color="primary" (click)="zoomIn()">
      <mat-icon>zoom_in</mat-icon>
      Zoom In
    </button>
    <!-- Move Controls -->
  <button mat-raised-button color="accent" (click)="moveLeft()">
    <mat-icon>chevron_left</mat-icon>
    Move Left
  </button>

  <button mat-raised-button color="accent" (click)="moveRight()">
    <mat-icon>chevron_right</mat-icon>
    Move Right
  </button>

  <button mat-raised-button color="accent" (click)="moveUp()">
      <mat-icon style="transform: rotate(90deg);">chevron_left</mat-icon>
    Move Up
  </button>

  <button mat-raised-button color="accent" (click)="moveDown()">
      <mat-icon style="transform: rotate(-90deg);" >chevron_left</mat-icon>
    Move Down
  </button>
  </div>
</div>

<mat-dialog-content>
  <image-cropper
    [imageChangedEvent]="data.imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="data.aspectRatio"
    [resizeToWidth]="data.resizeToWidth"
    format="png"
    (imageCropped)="imageCropped($event)"
    [(transform)]="transform"
  ></image-cropper>

  <div *ngIf="previewImage" class="mt-3 text-center">
    <img [src]="previewImage" alt="Preview" width="354" height="48" />
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
